import { useCallback } from 'react';
import { debounce } from 'utilities/helperFunctions';

export const useDebounce = (fn, waitTime) => useCallback(debounce(fn, waitTime), []);
